<template>
  <div class="menu" :class="{ show: $parent.menuVisible }">
    <div class="wrapper">
      <div class="container">
        <!-- Close Button -->
        <div class="menu-close" @click="$parent.closeMenu"></div>

        <!-- Navigation Links -->
        <div class="menu-section">
          <ul class="nav">
            <router-link
              to="/products"
              class="nav__item"
              @click="$parent.closeMenu"
            >
              <span class="title small nav-link">{{ $t(`ITEMS`) }}</span>
            </router-link>
            <li class="nav__item">
              <div
                class="title small nav-link"
                @click="scrollToSection('#how')"
              >
                {{ $t(`HOW TO JOIN`) }}
              </div>
            </li>
            <router-link
              to="/contact-us"
              class="nav__item"
              @click="$parent.closeMenu"
            >
              <span class="title small nav-link">
                {{ $t(`CONTACT FORM`) }}
              </span>
            </router-link>
          </ul>
        </div>

        <!-- User Actions -->
        <div class="menu-section" v-if="$parent.isAuth">
          <div class="balance">
            <button class="button profile-button dark">
              <div class="balance-text">
                <span class="title small gray">{{ $t(`Balance:`) }}</span>
                <span class="title small amount"
                  >{{ Math.floor($parent.profileData.balance * 100) / 100 }}
                  <img
                    src="../images/coin.svg"
                    class="currency-icon"
                    alt="coin"
                /></span>
              </div>
              <div class="button plus" @click="$parent.openTopUpModal">
                <img src="../images/plus.svg" class="img" />
              </div>
            </button>
          </div>
          <router-link
            to="/profile"
            class="button black profile-btn"
            @click="$parent.closeMenu"
            >{{ $t(`My profile`) }}</router-link
          >
        </div>

        <!-- Currency Selector -->
        <div class="menu-section">
          <div class="select-container currency-selector">
            <currency-dropdown
              v-model="curr"
              :options="currOptions"
              @change="selectCurr"
            />
          </div>
        </div>

        <!-- Login Section -->
        <div class="menu-section" v-if="!$parent.isAuth">
          <div class="button steam-login" @click="$parent.openSignInModal">
            <span>{{ $t(`LOGIN WITH STEAM`) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrencyDropdown from './CurrencyDropdown.vue'

export default {
  name: 'Menu',
  props: ['currency', 'currencyCode', 'currencyValue'],
  components: {
    CurrencyDropdown,
  },
  data: function () {
    return {
      topUpIsVisible: false,
      amount: 5,
      curr: '',
    }
  },
  computed: {
    currOptions() {
      return this.$parent.currencyOptions.map(({ code }) => code)
    },
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue
    },
  },
  mounted() {
    this.curr = this.currencyCode
  },
  methods: {
    selectCurr(selectedCurrency) {
      const nextValue =
        typeof selectedCurrency === 'string' ? selectedCurrency : this.curr
      this.curr = nextValue
      this.changeCurrency(nextValue)
      localStorage.setItem('currency', nextValue)
    },
    changeCurrency(item) {
      this.$emit('changeCurrency', item)
    },
    scrollToSection(section) {
      this.$parent.closeMenu()
      this.$emit('scrollToSection', section)
    },
    decrease() {
      if (this.amount > 0) {
        this.amount = this.amount - 1
      } else {
        this.amount = 0
      }
    },
    increase() {
      this.amount = this.amount + 1
    },
    toCheckout() {
      if (this.amount > 0) {
        this.topUpIsVisible = false
        this.$emit('setAmount', this.amount)
        this.$router.push({ path: 'cart', query: { amount: this.amount } })
      }
    },
  },
}
</script>
